import { useEffect, useRef, useState } from 'react';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { useWorkflowCheck } from '../WorkflowCheckProvider';
import { useWorkflowCheckOutdated } from '../useWorkflowCheckOutdated';
export const useAutoRunWorkflow = () => {
    const { isFeatureAvailable } = useCompanyFeatures();
    const isWorkflowsAvailable = isFeatureAvailable('DOCUMENT_ASSISTANT_WORKFLOWS');
    const { type, state, approvalResult, signatoryResult, approvalWorkflows, signatoryWorkflows, startCheck } = useWorkflowCheck();
    const { isApprovalOutdated, isSignatoryOutdated } = useWorkflowCheckOutdated();
    const result = type === 'approval' ? approvalResult : signatoryResult;
    const workflows = type === 'approval' ? approvalWorkflows : signatoryWorkflows;
    const isOutdated = type === 'approval' ? isApprovalOutdated : isSignatoryOutdated;
    const hasRanWorkflowCheck = Boolean(result.isChecked);
    const hasRanCheckRef = useRef(false);
    const [wasOutdatedOnMount] = useState(isOutdated);
    // If there is only one matching workflow and we haven't ran a workflow before → auto-run
    useEffect(() => {
        if (!isWorkflowsAvailable) {
            return;
        }
        if (hasRanCheckRef.current || state !== 'idle' || hasRanWorkflowCheck) {
            return;
        }
        if (workflows.length === 1) {
            hasRanCheckRef.current = true;
            startCheck(workflows[0].id);
        }
    }, [hasRanWorkflowCheck, isWorkflowsAvailable, startCheck, state, workflows]);
    // User entered the approval/eSigning tab after document was already updated → auto-run
    useEffect(() => {
        if (!isWorkflowsAvailable) {
            return;
        }
        if (hasRanCheckRef.current || state !== 'idle' || !wasOutdatedOnMount) {
            return;
        }
        if (workflows.length === 1) {
            hasRanCheckRef.current = true;
            startCheck(workflows[0].id);
        }
    }, [wasOutdatedOnMount, state, workflows, startCheck, isWorkflowsAvailable]);
};
